import React, { memo } from 'react';
import { Card, Statistic, Progress, Tooltip, Spin } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import styles from './statisticcard.module.css';
import { Colors } from '../../core/Theme';
import { Area, Column } from '@ant-design/charts';
import { formatNumber } from '../../../components/Percent';

interface StatisticCardProps {
  title: string,
  description?: string,
  value: string | number,
  loading: boolean,
  type: 'Line' | 'Percent' | 'Bar' | 'Value',
  additionalData?: any,
  image?: string,
  historicData?: { id: string, value: number, [key: string]: any }[]
}

class StatisticCard extends React.Component<StatisticCardProps> {

  renderLineChart = () => {
    const { historicData } = this.props;
    if(!historicData) return <></>;

    return <div style={{ width: '100%' }}>
      <Area 
      autoFit
      smooth
      xField="id"
      yField="value"
      yAxis={false}
      xAxis={false}
      height={40}
      padding={[5, -20]}
      tooltip={{
        position: 'top',
        formatter: (datum) => ({ name: 'Visitas', value: datum.value })
      }}
      color={Colors.charts.gray}
      data={historicData} />
      </div>
  }

  renderPercentBar = () => {
    const { value, additionalData } = this.props;
    return <Tooltip title={`${formatNumber(additionalData!.count, 0)} de ${formatNumber(additionalData!.total, 0)}`}><Progress strokeColor={Colors.charts.blue} percent={Number(value)*100} showInfo={false} /></Tooltip>;
  }

  renderBar = () => {
    const { historicData } = this.props;
    if(!historicData) return <></>;

    return <div style={{ width: '100%' }}>
      <Column data={historicData}
        yField="value" 
        xField="id"
        autoFit
        columnWidthRatio={0.9}
        height={40}
        padding={0}
        xAxis={false}
        yAxis={false}
        tooltip={{
          position: 'top',
          formatter: (datum) => ({ name: 'Tiempo Prom', value: datum.value.toFixed(2) + ' seg' })
        }}
        color={Colors.charts.greenish} />
    </div>;
  }

  renderValue = () => {
    return <></>;
  }

  render() {
    const { title, value, type, description, loading, image } = this.props;
    return <Card className={styles.card}>
      <div className={styles.heading}>
        <Statistic title={title} value={value} valueRender={(n) => loading ? <Spin /> : image ? <div style={{display: 'flex', alignItems: 'center'}}><img alt="" src={image} style={{width:'32px', marginRight:'8px'}} />{n}</div> : isNaN(Number(value)) ? n : formatNumber(value, 0, type === 'Percent' ? 'percent' : undefined) } />
        { description && <Tooltip title={description} trigger="click"><InfoCircleOutlined className={styles.infoIcon} /></Tooltip> }
      </div>
      { type !== 'Value' &&
        <div className={styles.content}>
          { type === 'Line' ? this.renderLineChart() : type === 'Percent' ? this.renderPercentBar() : type === 'Bar' ? this.renderBar() : <></>  }
        </div>
      }
      
    </Card>;
  }
}

export default memo(StatisticCard);
